
/*
 * CNHL Blog Buy Buttons
 * Read Product IDs from blog HTML.
 * Render Shopify Buy Button product sets.
 *
 * Usage:
 * <div class="cnhl-buy-buttons"
 *      data-product-ids="123456789,987654321"></div>
 */

(function () {
  "use strict";

  var SDK_URL =
    "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";

  var SHOP_DOMAIN = "cnhl-1.myshopify.com";

  // Public Storefront access token from existing Buy Button embed.
  var STOREFRONT_TOKEN = "4f4ad80deaa9399182df7b60a5242f8a";

  var SELECTOR = ".cnhl-buy-buttons[data-product-ids]";

  var sdkPromise = null;
  var uiPromise = null;

  // 1. Load Shopify Buy Button SDK once.
  function loadSDK() {
    if (sdkPromise) return sdkPromise;

    sdkPromise = new Promise(function (resolve, reject) {
      if (window.ShopifyBuy && window.ShopifyBuy.UI) {
        resolve(window.ShopifyBuy);
        return;
      }

      var script = document.createElement("script");

      script.src = SDK_URL;
      script.async = true;

      script.onload = function () {
        if (window.ShopifyBuy && window.ShopifyBuy.UI) {
          resolve(window.ShopifyBuy);
        } else {
          reject(new Error("Shopify Buy Button UI unavailable"));
        }
      };

      script.onerror = function () {
        reject(new Error("Unable to load Buy Button SDK"));
      };

      document.head.appendChild(script);
    });

    return sdkPromise;
  }

  // 2. Create one shared Shopify client/UI.
  function getUI() {
    if (uiPromise) return uiPromise;

    uiPromise = loadSDK().then(function (ShopifyBuy) {
      var client = ShopifyBuy.buildClient({
        domain: SHOP_DOMAIN,
        storefrontAccessToken: STOREFRONT_TOKEN
      });

      return ShopifyBuy.UI.onReady(client);
    });

    return uiPromise;
  }

  // 3. Preserve CNHL's existing product display style.
  function getOptions() {
    return {
      product: {
        styles: {
          product: {
            "flex": "0 0 calc(50% - 24px)",
            "max-width": "calc(50% - 24px)",
            "margin": "12px"
          },

          title: {
            "font-family": "Arial, sans-serif",
            "font-weight": "normal"
          },

          button: {
            "font-family": "Arial, sans-serif",
            "background-color": "#db007b",

            ":hover": {
              "background-color": "#c5006f"
            },

            ":focus": {
              "background-color": "#c5006f"
            },

            "border-radius": "12px"
          },

          price: {
            "color": "#df5959"
          },

          compareAt: {
            "color": "#df5959"
          },

          unitPrice: {
            "color": "#df5959"
          }
        },

        buttonDestination: "cart",

        text: {
          button: "Add to cart"
        }
      },

      productSet: {
        styles: {
          products: {
            "display": "flex",
            "flex-wrap": "wrap",
            "margin": "-12px"
          }
        }
      },

      option: {
        styles: {
          label: {
            "font-family": "Arial, sans-serif"
          },

          select: {
            "font-family": "Arial, sans-serif"
          }
        }
      },

      cart: {
        styles: {
          button: {
            "font-family": "Arial, sans-serif",
            "background-color": "#db007b",

            ":hover": {
              "background-color": "#c5006f"
            },

            ":focus": {
              "background-color": "#c5006f"
            },

            "border-radius": "12px"
          }
        },

        text: {
          total: "Subtotal",
          button: "Checkout"
        }
      }
    };
  }

  // 4. Read IDs from a product container.
  function getProductIDs(node) {
    var raw = node.getAttribute("data-product-ids") || "";

    return raw
      .split(",")
      .map(function (id) {
        return id.trim();
      })
      .filter(function (id) {
        return /^[0-9]+$/.test(id);
      });
  }

  // 5. Render a product set in the specified location.
  function renderProductSet(node, ui) {
    if (node.dataset.cnhlRendered === "true") return;

    var ids = getProductIDs(node);

    if (!ids.length) {
      console.warn("CNHL Buy Button: No valid Product IDs", node);
      return;
    }

    node.dataset.cnhlRendered = "true";

    try {
      var result = ui.createComponent("productSet", {
        id: ids,
        node: node,
        options: getOptions()
      });

      Promise.resolve(result).catch(function (error) {
        node.dataset.cnhlRendered = "false";
        console.error("CNHL product rendering failed:", error);
      });
    } catch (error) {
      node.dataset.cnhlRendered = "false";
      console.error("CNHL product rendering failed:", error);
    }
  }

  // 6. Find all product containers in the article.
  function init() {
    var nodes = document.querySelectorAll(SELECTOR);

    if (!nodes.length) return;

    getUI()
      .then(function (ui) {
        nodes.forEach(function (node) {
          renderProductSet(node, ui);
        });
      })
      .catch(function (error) {
        console.error("CNHL Buy Button initialization failed:", error);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
